import { HELP } from './helpTexts'
import { Card, HelpBody, PageHead } from './ui'

const PANELS: { title: string; body: string }[] = [
  { title: 'Áttekintés', body: 'A hatókörben (projekt vagy – csak globális adminnak – minden projekt) a kiválasztott időszak fő pénzügyi mutatói: bevétel, havi ismétlődő bevétel, előfizetések, sikertelen és ismeretlen kimenetű terhelések, tartozás. Alatta a 12 havi projektenkénti bevételdiagram, a bevétel forrás szerint, a projektek táblája, a legsúlyosabb tételek, a következő 7 nap várható terhelései és a kredit-egyenlegek pénznemenként.' },
  { title: 'Figyelmet igényel', body: 'Minden nyitott tétel egy listában, súlyosság szerint. A szűrő-gombok a probléma-típusokra szűrnek, mellettük a darabszám látszik. A „Teendő” gomb a meglévő műveleti oldalra visz (kredit, előfizetés-állapot); ahol még nincs ilyen oldal, a gomb „hamarosan” jelzéssel inaktív.' },
  { title: 'Felhasználó-kereső (360°)', body: 'Egy ügyfél teljes pénzügyi képe: előfizetések, kredit-egyenlegek, szűrhető idővonal, Stripe-napló és az ezen a felhasználón végzett admin-műveletek. Az e-mail az URL-ben van (?email=), így a nézet linkelhető.' },
  { title: 'Stripe-napló és Admin-műveletek', body: 'Lapozható naplók a hatókörben. A „Régebbiek” gomb a következő oldalt tölti be. Pénzügyi rekord soha nem törlődik.' },
  { title: 'Egyenlegből vagy kártyáról?', body: 'A megújításokat és feltöltéseket a rendszer előbb a számla egyenlegeiből fizeti (USDT, majd USDC, majd kredit, 1:1 USD), csak a maradék megy a kártyára. A Várható terhelések kártyán ezért „egyenlegből” és „kártyára” bontás látszik; a Figyelmet igényel listán az összeg alatt az egyenlegből fedezhető rész. Az egyenlegből fizetett megújítás az idővonalon „Egyenlegből fizetve” jelzést kap, és nem számít készpénz-bevételnek. Az ismeretlen kimenetű tételeknél az „egyenleg-fedezet” jelzés azt mondja meg, miért kell kézzel egyeztetni.' },
  { title: 'Hatókör és pénznemek', body: 'A projekt-admin csak a saját projektjeit látja; a globális admin ezen felül a „Minden projekt” nézetet is. Az összegek pénznemenként külön szerepelnek: nincs átváltás és nincs pénznemek közötti összeg. Az „—” azt jelenti, hogy az érték nem számolható (az ok az egérrel fölé víve látszik) – soha nem nulla.' },
  { title: 'Nézet-váltó', body: 'A fejlécben a Felhasználó | Admin kapcsoló csak annak jelenik meg, aki globális admin vagy legalább egy projekt adminja. A választás böngészőnként megjegyződik.' },
]

const ORDER: [string, string][] = [
  ['revenue', 'Befolyt bevétel'],
  ['mrr', 'MRR'],
  ['subscriptions', 'Aktív előfizetés'],
  ['failed', 'Sikertelen terhelés'],
  ['unknown', 'Ismeretlen kimenet'],
  ['overdue', 'Lejárt tartozás'],
  ['severity', 'Súlyosság'],
  ['attempt', 'Próbálkozás'],
  ['credits', 'Kredit-egyenlegek'],
  ['upcoming', 'Várható terhelések'],
  ['balanceRule', 'Egyenleg vagy kártya'],
  ['coverFlag', 'Egyenleg-fedezet jelzés'],
  ['atRisk', 'Rendezésre váró összeg'],
]

export function HelpPage() {
  return (
    <>
      <PageHead title="Súgó – admin pénzügyi nézet" sub="Melyik panel mit mutat és hogyan kell olvasni" />
      <div className="af-grid">
        {PANELS.map((p) => (
          <Card key={p.title}>
            <h2>{p.title}</h2>
            <p>{p.body}</p>
          </Card>
        ))}
      </div>
      <Card className="af-stack">
        <h2>Mutatók magyarázata</h2>
        {ORDER.filter(([k]) => HELP[k]).map(([k, label]) => (
          <div key={k}>
            <h3>{label}</h3>
            <HelpBody helpKey={k} />
          </div>
        ))}
        <p className="af-sub">Első nézetre érdemes: Figyelmet igényel → kritikus tételek (elvárt: 0), majd az Áttekintés ismeretlen kimenet és tartozás mutatója.</p>
      </Card>
    </>
  )
}
